<template>
  <div class="video">
    <div style="padding: 56.25% 0 0 0; position: relative">
      <iframe
        src="https://player.vimeo.com/video/784246058?h=b6d402bcd6&amp;autoplay=1&amp;muted=1&amp;loop=1&amp;badge=0&amp;player_id=0&amp;app_id=58479"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        title="Clavo &amp;ndash;&amp;nbsp;Work Time Planner"
      >
      </iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DisplayVideo',
}
</script>
<style lang="scss" scoped>
div {
  position: relative;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  // border: 1px solid $blue;
  line-height: 0;
  font-size: 0;
  border-radius: 6px;
  box-shadow: 0 9px 12px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;

  background-image: url(~@/assets/video-still.png);
  background-size: cover;

  @include respond-above(md) {
    width: $maxWidth;
  }
}
</style>
